import axios from "axios";
import * as Config from "../../Utils/Config";



export async function create_Contract(data) {
    try {
        const res = await axios.post(`${Config.base_url}create_contract`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Contract_Data(data) {
    try {
        const res = await axios.post(`${Config.base_url}get_contract`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Single_Package(data) {
    try {
        const res = await axios.post(`${Config.base_url}get_contract_ps`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Contract_Info(data) {
    try {
        const res = await axios.post(`${Config.base_url}getConractInfo`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Contract_Template(data) {
    try {
        const res = await axios.post(`${Config.base_url}getContractTemplate`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_Template_Content(data) {
    try {
        const res = await axios.post(`${Config.base_url}contract/gettemplatecontent`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}


export async function last_Five_Contract(data) {
    try {
        const res = await axios.post(`${Config.base_url}LastFiveContracts`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function delete_Contract(data) {
    try {
        const res = await axios.post(`${Config.base_url}delete_contract`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function get_AllQuotes(data) {
    try {
        const res = await axios.post(`${Config.base_url}getAllContracts`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function request_Higher_Discount(data) {
    try {
        const res = await axios.post(`${Config.base_url}request_higher_discount`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}

export async function client_Details_UpdateApi(data) {
    try {

        const res = await axios.post(`${Config.base_url}client_details_update`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}




export async function DownloadContract(data) {
    try {
        const res = await axios.post(`${Config.base_url}dawnloadcontract`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}


















